<template>
  <div class="preview-box">
    <span class="preview-box-link">此为临时链接，仅用于预览</span>
    <div class="show-content">
      <!-- <div class="show-tab-btn">
          <el-button :type="selectedPc" @click="tabShowcont('pc')">
            网页预览
          </el-button>
          <el-button :type="selectedPhone" @click="tabShowcont('phone')">
            手机预览
          </el-button>
          <el-button
            :type="selectedWechat"
            @click="tabShowcont('wechat')"
            v-if="$route.query.origin == '1'"
          >
            微信预览
          </el-button>
          <el-button
            :type="selectedWeibo"
            @click="tabShowcont('weibo')"
            v-if="$route.query.origin == '1'"
          >
            微博预览
          </el-button>
        </div> -->
      <div class="pc-preview-content" style="height: 100%; overflow: auto">
        <div
          class="manuscripts"
          style="height: 100%; overflow: hidden"
          v-if="articleType == '1'"
        >
          <div v-if="showPc == 'pc'" style="height: 100%; padding: 0 30px">
            <h2 class="news-title">{{ cont.webMsTitle }}</h2>
            <ul class="news-auter">
              <li v-if="cont.webMsSource" style="margin-left: 10px">
                {{ cont.webMsSource }}
              </li>
              <li>发布时间 ：{{ initTime(cont.createTime) }}</li>
              <!-- <li v-if="cont.webMsSource" style="margin-left: 10px">
                来源: {{ cont.webMsSource }}
              </li> -->
            </ul>
            <div class="news-content" v-html="cont.webClobHtml"></div>

            <div
              class="pc-bottom"
              v-if="cont.webMsAuthor != '' || cont.webMsReporter != ''"
            >
              <p v-if="cont.webMsAuthor != ''">
                <span></span>
                <span>编辑：{{ cont.webMsAuthor }}</span>
              </p>
              <p v-if="cont.webMsReporter != ''">
                <span></span>
                <span>责任编辑：{{ cont.webMsReporter }}</span>
              </p>
            </div>
            <!-- <ul style="color:#A8B1BB;line-height:28px;font-size: 14px;margin-top: 6px;">
                <li>编辑: {{cont.webMsReporter||''}}</li>
                <li>作者: {{cont.webMsAuthor||''}}</li>
              </ul> -->
          </div>
          <div v-if="showPc == 'phone'">
            <div class="phone-box">
              <div class="phone-box-content">
                <h2 class="phone-title">{{ cont.webMsTitle }}</h2>
                <ul class="phone-auter">
                  <li>{{ cont.createTime }}</li>
                </ul>
                <div class="phone-content" v-html="cont.webClobHtml"></div>
                <div
                  class="phone-bottom"
                  v-if="cont.webMsAuthor != '' || cont.webMsReporter != ''"
                >
                  <p v-if="cont.webMsAuthor != ''">
                    <span></span>
                    <span>编辑：{{ cont.webMsAuthor }}</span>
                  </p>
                  <p v-if="cont.webMsReporter != ''">
                    <span></span>
                    <span>责任编辑：{{ cont.webMsReporter }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-if="showPc == 'weibo'" style="height: 100%" class="weibo">
              <h2 class="news-title">{{ cont.webMsTitle }}</h2>
              <ul class="news-auter">
                <li>{{ initTime(cont.createTime) }}</li>
                <li v-if="cont.webMsSource" style="margin-left: 10px">
                  来源: {{ cont.webMsSource }}
                </li>
              </ul>
              <div class="news-content" v-html="cont.webClobHtml"></div>
            </div>
            <div v-if="showPc == 'wechat'" class="wechat">
              <div class="phone-box">
                <div class="phone-box-content">
                  <h2 class="phone-title">{{ cont.webMsTitle }}</h2>
                  <ul class="phone-auter">
                    <li>{{ initTime(cont.createTime) }}</li>
                    <li v-if="cont.webMsSource" style="margin-left: 10px">
                      来源: {{ cont.webMsSource }}
                    </li>
                  </ul>
                  <div class="phone-content" v-html="cont.webClobHtml"></div>
                </div>
              </div>
            </div> -->
        </div>
        <div class="atlas" v-if="articleType == '4'">
          <div v-if="showPc == 'pc'" style="padding: 0 30px">
            <h2 class="news-title">{{ cont.webMsTitle }}</h2>
            <ul class="news-auter">
              <li v-if="cont.webMsSource" style="margin-left: 10px">
                {{ cont.webMsSource }}
              </li>
              <li>发布时间: {{ initTime(cont.createTime) }}</li>
            </ul>
            <div class="news-content atlas-content">
              <el-carousel height="750px" :autoplay="false">
                <el-carousel-item
                  v-for="(item, index) in currentInfo"
                  :key="index"
                >
                  <p class="atlas-img-box">
                    <img class="atlas-img" :src="item.url" alt="" />
                  </p>
                  <p class="atlas-describe">
                    <span class="describe-index"
                      ><i>{{ index + 1 }}</i
                      >/{{ currentInfo.length }}</span
                    >
                    <span class="describe-cont">{{ cont.webMsSummary }}</span>
                  </p>
                  <div
                    class="pc-bottom"
                    v-if="cont.webMsAuthor != '' || cont.webMsReporter != ''"
                  >
                    <p v-if="cont.webMsAuthor != ''">
                      <span></span>
                      <span>编辑：{{ cont.webMsAuthor }}</span>
                    </p>
                    <p v-if="cont.webMsReporter != ''">
                      <span></span>
                      <span>责任编辑：{{ cont.webMsReporter }}</span>
                    </p>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div v-if="showPc == 'phone'">
            <div class="phone-box atlas-phone-box">
              <div class="phone-box-content atlas-content">
                <h2 class="phone-title">{{ cont.webMsTitle }}</h2>
                <ul class="phone-auter">
                  <li v-if="cont.webMsSource" style="margin-left: 10px">
                    {{ cont.webMsSource }}
                  </li>
                  <li>发布时间: {{ cont.createTime }}</li>
                </ul>

                <el-carousel height="307px" :autoplay="false">
                  <el-carousel-item
                    v-for="(item, index) in currentInfo"
                    :key="index"
                  >
                    <div class="atlas-phone-img-box">
                      <img class="atlas-phone-img" :src="item.url" alt="" />
                    </div>
                    <span class="describe-index-phone" style="color: #fff"
                      ><i style="color: #ef983c">{{ index + 1 }}</i
                      >/{{ currentInfo.length }}</span
                    >
                    <p class="phone-atlas-describe">
                      <span class="describe-cont">{{ cont.webMsSummary }}</span>
                    </p>
                    <!-- <p class="atlas-info">{{ cont.webMsSummary }}</p> -->
                  </el-carousel-item>
                </el-carousel>
                <div
                  class="phone-bottom"
                  v-if="cont.webMsAuthor != '' || cont.webMsReporter != ''"
                >
                  <p v-if="cont.webMsAuthor != ''">
                    <span></span>
                    <span>编辑：{{ cont.webMsAuthor }}</span>
                  </p>
                  <p v-if="cont.webMsReporter != ''">
                    <span></span>
                    <span>责任编辑：{{ cont.webMsAuthor }}</span>
                  </p>
                </div>
                <!-- <div class="comment">
                  <el-input
                    size="small"
                    v-model="input"
                    placeholder="发表你的观点"
                  ></el-input>
                  <div class="icon-box">
                    <img
                      :src="require('@/assets/preview/collect.png')"
                      alt=""
                    />
                    <img :src="require('@/assets/preview/share1.png')" alt="" />
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="video" v-if="articleType == '2'">
          <div v-if="showPc == 'pc'" style="padding: 0 39px; height: 93vh">
            <h2 class="news-title">{{ cont.webMsTitle }}</h2>
            <ul class="news-auter">
              <li v-if="cont.webMsSource" style="margin-left: 10px">
                {{ cont.webMsSource }}
              </li>
              <li>发布时间: {{ initTime(cont.createTime) }}</li>
            </ul>
            <div class="video-content">
              <vue-aliplayer-v2
                class="preview-video"
                :sourceUrl="
                  currentInfo[0].url == '' ? cont.webMsLink : currentInfo[0].url
                "
                ref="VueAliplayerV2"
              />
              <div class="video-content-info">
                <p v-if="cont.webMsSummary">{{ cont.webMsSummary }}</p>
                <div
                  class="pc-bottom"
                  v-if="cont.webMsAuthor != '' || cont.webMsReporter != ''"
                >
                  <p v-if="cont.webMsAuthor != ''">
                    <span></span>
                    <span>编辑：{{ cont.webMsAuthor }}</span>
                  </p>
                  <p v-if="cont.webMsReporter != ''">
                    <span></span>
                    <span>责任编辑：{{ cont.webMsReporter }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showPc == 'phone'">
            <div class="phone-box">
              <div class="video-phone-content">
                <div class="phone-video-content">
                  <vue-aliplayer-v2
                    class="preview-video"
                    :sourceUrl="
                      currentInfo[0].url == ''
                        ? cont.webMsLink
                        : currentInfo[0].url
                    "
                    ref="VueAliplayerV2"
                  />
                  <!-- <vueMiniPlayer
                    ref="vueMiniPlayer"
                    :video="video"
                    :mutex="true"
                    @fullscreen="handleFullscreen"
                  /> -->
                  <!-- <video
                    :src="
                      currentInfo[0].url == ''
                        ? cont.webMsLink
                        : currentInfo[0].url
                    "
                   contros  style="width:100%;height:100%"></video> -->
                </div>
                <h2
                  class="phone-title"
                  style="padding-left: 16px; margin: 20px 0 12px 0"
                >
                  {{ cont.webMsTitle }}
                </h2>
                <div class="user-info">
                  <!-- <div class="header">
                      <img :src="require('@/assets/preview/audio_pause.png')" alt=""/>
                    </div> -->
                  <ul class="info-phone-auter" style="padding-left: 16px">
                    <li v-if="cont.webMsSource" style="margin-left: 10px">
                      {{ cont.webMsSource }}
                    </li>
                    <li>发布时间：{{ cont.createTime }}</li>
                  </ul>
                </div>
                <div class="content-info" v-if="cont.webMsSummary">
                  {{ cont.webMsSummary }}
                </div>
                <div
                  class="phone-bottom"
                  v-if="cont.webMsAuthor != '' || cont.webMsReporter != ''"
                >
                  <p v-if="cont.webMsAuthor != ''">
                    <span></span>
                    <span>编辑：{{ cont.webMsAuthor }}</span>
                  </p>
                  <p v-if="cont.webMsReporter != ''">
                    <span></span>
                    <span>责任编辑：{{ cont.webMsAuthor }}</span>
                  </p>
                </div>
                <!-- 相关推荐 -->
                <div class="recommend" v-if="cont.linksList">
                  <h2>相关推荐</h2>
                  <ul class="news-recommended-box">
                    <li
                      v-for="(val, ind) in cont.linksList"
                      :key="ind"
                      class="recommend-flex"
                    >
                      <div class="cover-img">
                        <img :src="val.coverimgPathList[0]" alt="" />
                      </div>
                      <div class="right-recommended">
                        <div class="recommended-title">{{ val.title }}</div>
                        <div class="recommend-flex recommended-info">
                          <span>
                            <i style="margin-right: 5px">{{
                              val.createUser
                            }}</i>
                            <i>{{ getDate(val.releaseCreateTime) }}</i>
                          </span>
                          <span>{{ val.releaseNum }}播放量</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="audio" v-if="articleType == '3'">
          <div v-if="showPc == 'pc'" style="padding: 0 30px">
            <h2 class="news-title">{{ cont.webMsTitle }}</h2>
            <ul class="news-auter">
              <li v-if="cont.webMsSource" style="margin-left: 10px">
                {{ cont.webMsSource }}
              </li>
              <li>发布时间: {{ initTime(cont.createTime) }}</li>
            </ul>
            <div
              :class="
                this.audio.playing ? 'play-audio-content' : 'audio-content'
              "
            >
              <img
                v-if="this.audio.playing"
                class="gif-img"
                :src="require('@/assets/preview/audio-back.gif')"
                alt=""
              />
              <audio
                ref="audio"
                @pause="onPause"
                @play="onPlay"
                @timeupdate="onTimeupdate"
                @loadedmetadata="onLoadedmetadata"
                :src="
                  currentInfo[0].url == '' ? cont.webMsLink : currentInfo[0].url
                "
                controls="controls"
                style="display: none"
              ></audio>
              <div class="control-box">
                <!-- 进度条 -->
                <div class="audio-progress">
                  <el-slider
                    v-model="sliderTime"
                    :format-tooltip="formatProcessToolTip"
                    @change="changeCurrentTime"
                    class="slider"
                  ></el-slider>
                </div>
                <!-- 音频播放控件 -->
                <div class="audio-control">
                  <div class="control-left">
                    <div class="audio-btn">
                      <el-button
                        v-if="!this.audio.playing"
                        type="text"
                        @click="play"
                        ><img
                          :src="require('@/assets/preview/palying.png')"
                          alt=""
                      /></el-button>
                      <el-button v-else type="text" @click="pause"
                        ><img
                          :src="require('@/assets/preview/pause.png')"
                          alt=""
                      /></el-button>
                    </div>
                    <p class="audio-time">
                      <span>{{ realFormatSecond(this.audio.currentTime) }}</span
                      >/
                      <span>{{ audioInfo.time }}</span>
                    </p>
                  </div>
                  <div class="audio-sound">
                    <el-slider
                      class="sound-slider"
                      style="width: 100px; cursor: pointer"
                      v-model="soundValue"
                      @change="getChange"
                    ></el-slider>
                    <div
                      id="player_sound_btn_player"
                      volume="50"
                      ismute="false"
                      @click="showSound"
                      @mouseenter="showMouse = true"
                      @mouseleave="showMouse = false"
                    >
                      <img
                        v-if="!sound && !showMouse"
                        id="player_sound_yes_player"
                        src="@/assets/preview/sound.png"
                      />
                      <img
                        v-if="sound && !showMouse"
                        id="player_sound_no_player"
                        src="@/assets/preview/sound-no.png"
                      />
                      <img
                        v-if="!sound && showMouse"
                        id="player_sound_yes_player"
                        src="@/assets/preview/sound-hover.png"
                      />
                      <img
                        v-if="sound && showMouse"
                        id="player_sound_yes_player"
                        src="@/assets/preview/sound-no-hover.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="video-content-info">
              <p v-if="cont.webMsSummary">{{ cont.webMsSummary }}</p>
              <div
                class="pc-bottom"
                v-if="
                  (cont.webMsAuthor != '' && cont.webMsAuthor) ||
                  (cont.webMsReporter != '' && cont.webMsReporter)
                "
              >
                <p v-if="cont.webMsAuthor != ''">
                  <span></span>
                  <span>编辑：{{ cont.webMsAuthor }}</span>
                </p>
                <p v-if="cont.webMsReporter != ''">
                  <span></span>
                  <span>责任编辑：{{ cont.webMsReporter }}</span>
                </p>
              </div>
            </div>
          </div>
          <div v-if="showPc == 'phone'">
            <div class="phone-box">
              <div class="audio-phone-content">
                <div class="phone-audio-content">
                  <audio
                    ref="audio"
                    @pause="onPause"
                    @play="onPlay"
                    @timeupdate="onTimeupdate"
                    @loadedmetadata="onLoadedmetadata"
                    :src="
                      currentInfo[0].url == ''
                        ? cont.webMsLink
                        : currentInfo[0].url
                    "
                    controls="controls"
                    style="display: none"
                  ></audio>
                  <div class="show-audio">
                    <img
                      :class="this.audio.playing ? 'adimat-box' : ''"
                      :src="require('@/assets/preview/audiobg.png')"
                      alt=""
                    />
                  </div>
                  <div class="audio-phone-control">
                    <span class="audio-phone-time">{{
                      realFormatSecond(this.audio.currentTime)
                    }}</span>
                    <div class="audio-phone-progress">
                      <el-slider
                        v-model="sliderTime"
                        :format-tooltip="formatProcessToolTip"
                        @change="changeCurrentTime"
                        class="slider"
                      ></el-slider>
                    </div>
                    <span class="audio-phone-time">{{ audioInfo.time }}</span>
                  </div>
                  <div class="audio-phone-button">
                    <img
                      v-if="!this.audio.playing"
                      @click="play"
                      :src="require('@/assets/preview/audio_paly.png')"
                      alt=""
                    />
                    <img
                      v-else
                      @click="pause"
                      :src="require('@/assets/preview/audio_pause.png')"
                      alt=""
                    />
                  </div>
                </div>
                <h2 class="phone-title">{{ cont.webMsTitle }}</h2>
                <div class="user-info">
                  <!-- <div class="header">
                      <img :src="require('@/assets/preview/audio_pause.png')" alt="">
                    </div> -->
                  <ul class="info-phone-auter">
                    <li v-if="cont.webMsSource" style="margin-left: 10px">
                      {{ cont.webMsSource }}
                    </li>
                    <li>{{ cont.createTime }}</li>
                  </ul>
                  <!-- <div class="follow">
                      <img v-if="followBtn" @click="followBtn=!followBtn" :src="require('@/assets/preview/follow_on.png')" alt="" />
                      <img v-if="!followBtn" @click="followBtn=!followBtn" :src="require('@/assets/preview/follow_no.png')" alt="" />
                    </div> -->
                </div>
                <div
                  class="content-info"
                  v-if="cont.webMsSummary"
                  style="padding: 0"
                >
                  {{ cont.webMsSummary }}
                </div>
                <!-- 相关推荐 -->
                <div class="recommend" v-if="cont.linksList">
                  <h2>相关推荐</h2>
                  <ul class="news-recommended-box">
                    <li
                      v-for="(val, ind) in cont.linksList"
                      :key="ind"
                      class="recommend-flex"
                    >
                      <div class="cover-img">
                        <img :src="val.coverimgPathList[0]" alt="" />
                      </div>
                      <div class="right-recommended">
                        <div class="recommended-title">{{ val.title }}</div>
                        <div class="recommend-flex recommended-info">
                          <span>
                            <i style="margin-right: 5px">{{
                              val.createUser
                            }}</i>
                            <i>{{ getDate(val.releaseCreateTime) }}</i>
                          </span>
                          <span>{{ val.releaseNum }}播放量</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  class="phone-bottom"
                  v-if="cont.webMsAuthor != '' || cont.webMsReporter != ''"
                  style="padding: 0"
                >
                  <p v-if="cont.webMsAuthor != ''">
                    <span></span>
                    <span>编辑：{{ cont.webMsAuthor }}</span>
                  </p>
                  <p v-if="cont.webMsReporter != ''">
                    <span></span>
                    <span>责任编辑：{{ cont.webMsReporter }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import VueAliplayerV2 from "@/components/playerbox/livePlayer";
import { getManuscript } from "@/api/sectionPreview/index";
import { filePerviewPath } from "@/api/ActivitySolicitation/index";
export default {
  data() {
    return {
      showMouse: false,
      followBtn: false,
      newSoundValue: 75,
      soundValue: 75,
      sound: false,
      input: "",
      showPc: "pc",
      selectedPc: "primary",
      selectedPhone: "",
      selectedWechat: "",
      selectedWeibo: "",
      articleType: "",
      cont: {},
      waterData: {},
      wmkOptions: [],
      sliderTime: 0,
      audioDetail: {},
      audioInfo: {
        time: 0,
      },
      currentInfo: [{ url: "" }],
      progressing_audio: 0,
      audio: {
        // 该字段是音频是否处于播放状态的属性
        playing: false,
        // 音频当前播放时长
        currentTime: 0,
        // 音频最大播放时长
        maxTime: 0,
      },
    };
  },
  computed: {
    $video() {
      return this.$refs.vueMiniPlayer.$video;
    },
  },
  components: {
    VueAliplayerV2,
  },
  async created() {
    document.title = "测试";
    var isMobile = {
      Android: function () {
        //
        return navigator.userAgent.match(/Android/i) ? true : false;
      },
      BlackBerry: function () {
        //黑莓
        return navigator.userAgent.match(/BlackBerry/i) ? true : false;
      },
      iOS: function () {
        //ios
        return navigator.userAgent.match(/iPhone|iPad|iPod/i) ? true : false;
      },
      Windows: function () {
        //
        return navigator.userAgent.match(/IEMobile/i) ? true : false;
      },

      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Windows()
        );
      },
    };
    //如果返回为true，说明当前是在手机打开该网站
    console.log(
      window.screen.width,
      isMobile.any() || (window.screen.width > 350 && window.screen.width < 400)
    );
    if (
      isMobile.any() ||
      (window.screen.width > 350 && window.screen.width < 400)
    ) {
      console.log(999999, "手机");
      this.showPc = "phone";
      //操作
    } else {
      this.showPc = "pc";
      console.log(999999, "电脑");
      let element = document.documentElement;
      let body = document.body;
      element.style.maxWidth = 1200 + "px";
      body.style.maxWidth = 1200 + "px";
    }

    // this.getWaterOptions()
    this.articleType = this.$route.query.type;
    console.log(this.articleType, this.showPc);
    if (this.$route.query.id) {
      await this.getNewsDetails(this.$route.query.id, this.$route.query.type);
    } else {
      this.cont = {
        ...this.cont,
        ...JSON.parse(window.localStorage.getItem("newDetails")),
      };
    }

    // this.tabShowcont("pc");
  },
  methods: {
    handleFullscreen() {},
    // tabShowcont(tab) {
    //   this.showPc = tab;
    //   if (tab == "pc") {
    //     (this.selectedPc = "primary"), (this.selectedPhone = "");
    //     this.selectedWechat = "";
    //     this.selectedWeibo = "";
    //   } else if (tab == "phone") {
    //     console.log(878676, tab);
    //     (this.selectedPc = ""), (this.selectedPhone = "primary");
    //     this.selectedWechat = "";
    //     this.selectedWeibo = "";
    //   } else if (tab == "wechat") {
    //     (this.selectedPc = ""), (this.selectedPhone = "");
    //     this.selectedWechat = "primary";
    //     this.selectedWeibo = "";
    //   } else if (tab == "weibo") {
    //     (this.selectedPc = ""), (this.selectedPhone = "");
    //     this.selectedWechat = "";
    //     this.selectedWeibo = "primary";
    //   }
    //   this.$forceUpdate();
    // },
    // 获取文章水印列表
    // getWaterOptions() {
    //   let obj = {
    //     pageIndex: 1,
    //     pageSize: 99999,
    //     wmkRange: 1,
    //   };
    //   this.$http
    //     .get(this.$api.watermarkList, { params: obj })
    //     .then((res) => {
    //       if (res.data.status === 0 && res.data.data.list) {
    //         this.wmkOptions = res.data.data.list;
    //       } else [(this.wmkOptions = [])];
    //     })
    //     .finally(() => {
    //       if (this.$route.params.id == "noid") {
    //         this.cont = {
    //           ...this.cont,
    //           ...JSON.parse(window.localStorage.getItem("newDetails")),
    //         };
    //         var waterData = this.wmkOptions.filter((val) => {
    //           return val.wmkId == this.cont.wmkId;
    //         });
    //         this.waterData = waterData[0];
    //       } else {
    //         this.getNewsDetails(this.$route.params.id, this.$route.query.type);
    //       }
    //     });
    // },
    //打开相关推荐
    openDetils(id) {
      // this.$router.push(`/newsDetails/${id}`);
    },
    //查询新闻详情
    async getNewsDetails(id, type) {
      await getManuscript({ id }).then(({ data }) => {
        if (data.code == 200) {
          this.cont = { ...this.cont, ...data.data };

          this.currentInfo = data.data.webManuscriptObjEntities;
          console.log("ziyuan", this.currentInfo);
          console.log(this.cont, this.currentInfo);
          // this.currentInfo[0].url = this.cont.webMsLink;
          if (this.currentInfo.length > 0) {
            this.currentInfo.forEach((item) => {
              let params = {
                id: item.fileObjId,
                type: "transcode",
              };
              item.url = filePerviewPath(params);
            });
          } else {
            this.currentInfo.push({
              url: data.data.webMsLink,
            });
          }
          var waterData = this.wmkOptions.filter((val) => {
            return val.wmkId == this.cont.wmkId;
          });
          this.waterData = waterData[0];
        }
      });
    },
    getDate(time) {
      let Time;
      if (time) {
        Time = new Date(time);
      } else {
        Time = new Date();
      }
      let m = Time.getMonth() + 1;
      let d = Time.getDate();
      m = m > 9 ? m : "0" + m;
      d = d > 9 ? d : "0" + d;
      return `${m}-${d}`;
    },
    initTime(time) {
      let Time;
      if (time) {
        Time = new Date(time);
      } else {
        Time = new Date();
      }
      let y = Time.getFullYear();
      let m = Time.getMonth() + 1;
      let d = Time.getDate();
      let h = Time.getHours();
      let mm = Time.getMinutes();
      let s = Time.getSeconds();
      // ${y}-${m}-${d} ${h}:${mm}:${s}
      return `${y}-${m}-${d} ${h}:${mm}:${s}`;
    },
    // 音频时间
    realFormatSecond(second) {
      var secondType = typeof second;
      if (secondType === "number" || secondType === "string") {
        second = parseInt(second);
        var hours = Math.floor(second / 3600);
        second = second - hours * 3600;
        var mimute = Math.floor(second / 60);
        second = second - mimute * 60;
        //   return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
        return ("0" + mimute).slice(-2) + ":" + ("0" + second).slice(-2);
      } else {
        return "00:00";
      }
    },
    // 控制音频的播放与暂停
    startPlayOrPause() {
      return this.audio.playing ? this.pause() : this.play();
    },

    // 播放音频
    play() {
      this.$refs.audio.play();
      this.timer = setInterval(() => {
        this.progressing_audio =
          (this.progressing_audio / 100 + 0.1 / this.audio.maxTime) * 100;
        this.second = this.second + 0.1;
        if (this.progressing_audio >= 100) {
          clearInterval(this.timer);
          this.progressing_audio = 0;
          this.second = 0;
        }
      }, 100);
    },
    // 暂停音频
    pause() {
      this.$refs.audio.pause();
      clearInterval(this.timer);
    },
    // 当音频播放
    onPlay() {
      this.audio.playing = true;
    },
    // 当音频暂停
    onPause() {
      this.audio.playing = false;
    },
    // 进度条toolTip
    formatProcessToolTip(index) {
      index = parseInt((this.audio.maxTime / 100) * index);
      return "进度条: " + this.realFormatSecond(index);
    },
    // 播放跳转
    changeCurrentTime(index) {
      this.$refs.audio.currentTime = parseInt(
        (index / 100) * this.audio.maxTime
      );
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      this.audio.currentTime = res.target.currentTime;
      this.sliderTime = (this.audio.currentTime / this.audio.maxTime) * 100;
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata(res) {
      this.audioInfo.time = this.realFormatSecond(
        parseInt(res.target.duration)
      );
      this.audio.maxTime = parseInt(res.target.duration);
    },
    showSound() {
      //声音
      this.sound = !this.sound;
      if (this.sound) {
        this.soundValue = 0;
        this.$refs.audio.volume = this.soundValue / 100;
      } else {
        this.soundValue = this.newSoundValue;
        this.$refs.audio.volume = this.soundValue / 100;
      }
    },
    getChange() {
      this.sound = false;
      this.newSoundValue = this.soundValue;
      this.$refs.audio.volume = this.newSoundValue / 100;
    },
  },
  filters: {
    // 使用组件过滤器来动态改变按钮的显示
    transPlayPause(value) {
      return value ? "el-icon-video-pause" : "el-icon-video-play";
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>
  <style scoped>
@import "./previw.css";
.atlas-content.news-content >>> .el-carousel {
  height: 750px !important;
}
.atlas-content.phone-box-content >>> .el-carousel {
  /* height: 400px !important; */
}
.phone-content >>> img {
  max-width: 290px !important;
}
.news-content .el-carousel >>> .el-carousel__arrow {
  width: 40px;
  height: 40px;
  border-radius: 50;
  background-color: rgb(45, 45, 45);
  top: 36%;
}
.news-content >>> img {
  margin: 0px auto;
}
.atlas-content .el-carousel >>> .el-carousel__indicators {
  display: none;
}
.comment .el-input >>> .el-input__inner {
  border-radius: 16px;
  background-color: #7d7d7d;
  border: none;
}
.video-content
  >>> .vjs-custom-skin
  > .video-js
  .vjs-progress-control.vjs-control {
  visibility: inherit;
}
.audio-progress >>> .el-progress-bar {
  padding: 0;
}
.audio-progress >>> .el-slider__bar {
  background-color: #ff534d;
}
.audio-progress >>> .el-slider__button {
  width: 8px;
  height: 8px;
  margin-top: -0.75rem;
}
.audio-sound .sound-slider >>> .el-slider__bar {
  background-color: #ff534d;
}
.audio-sound .sound-slider >>> .el-slider__button {
  width: 8px;
  height: 8px;
  margin-top: -0.75rem;
}
.audio-phone-progress >>> .el-slider__bar {
  height: 2px;
  background-color: #ff534d;
}
.audio-phone-progress >>> .el-slider__runway {
  height: 2px;
}
.audio-phone-progress >>> .el-slider__button {
  width: 3px;
  height: 3px;
  /* margin-bottom: 0.4rem; */
}
.audio-phone-progress /deep/.el-slider__button-wrapper {
  top: -0.67em;
}
.atlas-phone-box .atlas-content >>> .el-carousel__arrow {
  top: 41% !important;
  /* background-color: rgba(0, 0, 0, 0.5); */
}
.atlas-phone-box .atlas-content >>> .el-carousel__arrow i {
  font-size: 20px;
}
.news-content.atlas-content >>> .el-carousel__arrow i {
  font-size: 24px;
}

.manuscripts .phone-content >>> p,
.manuscripts .news-content >>> p {
  margin: 0 0 16px 0;
  text-indent: 0 !important;
  min-height: 18px;
}

.manuscripts .phone-content >>> img,
.manuscripts .news-content >>> img {
  display: block;
  margin: 5px auto;
  max-width: 100%;
  object-fit: scale-down;
}

.manuscripts .phone-content >>> video,
.manuscripts .news-content >>> video {
  width: 100%;
  height: 200px;
  display: block;
  margin: 0 auto;
  max-width: 100%;
  background-color: #000;
}
.manuscripts .phone-content >>> h1,
.manuscripts .news-content >>> h1 {
  font-size: 32px;
}
.manuscripts .phone-content >>> h3,
.manuscripts .news-content >>> h3 {
  font-size: 19px;
  margin-bottom: 16px;
}
.manuscripts .phone-content >>> h3 > p,
.manuscripts .news-content >>> h3 > p {
  margin-bottom: 16px;
}
.manuscripts .phone-content >>> h1,
.manuscripts .phone-content >>> h3,
.manuscripts .news-content >>> h1,
.manuscripts .news-content >>> h3 {
  color: #0d141e;
  font-weight: bold;
}
.manuscripts .phone-content >>> strong,
.manuscripts .news-content >>> strong {
  font-weight: bold;
}
.manuscripts .phone-content >>> a,
.manuscripts .news-content >>> a {
  color: #153d9a;
  font-weight: bold;
  text-decoration: none;
  border-bottom: 0.0625rem solid #153d9a;
}
.manuscripts .phone-content >>> hr,
.manuscripts .news-content >>> hr {
  margin: 40px 20px;
}
</style>